<template>
  <v-row no-gutters>
    <v-col cols="12" style="position: relative;">
      <v-tabs
        v-model="tab"
        background-color="transparent"
        class="mb-8"
        slider-color="orange"
        centered
      >
        <v-tab>{{ $t("message.common.currentData") }}</v-tab>
        <v-tab>{{ $t("message.common.history") }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" class="transparent">
        <v-tab-item>
          <v-expansion-panels
            v-for="item in auditArr"
            :key="item.id"
            class="mb-4"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-row no-gutters>
                  <v-col cols="6" lg="4">
                    <Progress
                      :name="$t(`message.common.${item.id}`)"
                      :value="Math.round(item.score.last_value * 100)"
                      :tooltip="item.tooltip"
                    />
                  </v-col>
                  <v-col cols="6" lg="8" class="pl-5">
                    <v-row no-gutters>
                      <v-col cols="12" lg="4">
                        <HeaderDefault
                          :label="$t('message.analytics.wellDone')"
                          :value="item.audits.passed.length"
                        />
                      </v-col>
                      <v-col cols="12" lg="4">
                        <HeaderDefault
                          :label="$t('message.analytics.needFix')"
                          :value="item.audits.failed.length"
                        />
                      </v-col>
                      <v-col cols="12" lg="4">
                        <LastAudit :lastAudit="item.score.diff" />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <!-- <Heading
                  title="Czym jest wydajność"
                  description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                /> -->
                <v-row no-gutters>
                  <v-col cols="12" lg="6" class="px-4">
                    <h3 class="mb-3 mt-5">
                      {{ $t("message.analytics.wellDone") }}
                    </h3>
                    <AuditSummaryIndicator
                      v-for="(indicator, index) in item.audits.passed"
                      :key="indicator.id"
                      class="indicator"
                      :indicator="{
                        type: 'success',
                        name: indicator.title,
                        description: indicator.description
                      }"
                      :grayBg="!((index + 2) % 2)"
                    />
                  </v-col>
                  <v-col cols="12" lg="6" class="px-4">
                    <h3 class="mb-3 mt-5">
                      {{ $t("message.analytics.needFix") }}
                    </h3>
                    <AuditSummaryIndicator
                      v-for="(indicator, index) in item.audits.failed"
                      :key="indicator.id"
                      class="indicator"
                      :indicator="{
                        type: 'error',
                        description: indicator.description,
                        name: indicator.title
                      }"
                      :grayBg="!((index + 2) % 2)"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-tab-item>
        <v-tab-item>
          <v-card class="pa-5">
            <CustomChartLegend />
            <template v-if="chartData.data && chartData.labels.length > 0">
              <LineChart
                :height="400"
                :data="chartData.data"
                :labels="chartData.labels"
              />
            </template>
            <template v-else>
              <v-row no-gutters>
                <v-col
                  cols="12"
                  class="d-flex justify-center align-center flex-column"
                  style="height: 400px;"
                >
                  <v-icon x-large class="ma-2" color="primary">
                    mdi-database-search
                  </v-icon>
                  <h3>{{ $t("message.common.noData") }}</h3>
                </v-col>
              </v-row>
            </template>
            <ChartPagination
              @changeMonth="changeMonth"
              :currentMonth="currentMonth"
            />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      <SectionLoader :status="loadingChart" />
    </v-col>
  </v-row>
</template>

<script>
import LastAudit from "@/components/ui/ExpansionPanel/Header/LastAudit.vue";
import HeaderDefault from "@/components/ui/ExpansionPanel/Header/Default.vue";
import Progress from "@/components/ui/ExpansionPanel/Header/Progress.vue";
import Heading from "@/components/ui/ExpansionPanel/Content/Heading//Heading.vue";
import AuditSummaryIndicator from "@/components/Analytics/AuditSummaryIndicator.vue";
import LineChart from "@/components/Analytics/AuditSummary/chart.js";
import CustomChartLegend from "@/components/Analytics/AuditSummary/CustomChartLegend";
import ChartPagination from "@/components/Chart/Pagination.vue";
import SectionLoader from "@/components/Loader/SectionLoader.vue";

import moment from "moment";

import omit from "lodash/omit";

export default {
  name: "AnalyticsAuditSummary",
  components: {
    LastAudit,
    HeaderDefault,
    Progress,
    // Heading,
    AuditSummaryIndicator,
    LineChart,
    ChartPagination,
    CustomChartLegend,
    SectionLoader
  },
  props: {
    selectedItem: {
      type: Object,
      required: true
    },
    audit: {
      type: Object,
      required: true
    },
    chartData: {
      type: Object,
      required: true
    },
    loadingChart: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentMonth: {},
      tab: null,
      tooltips: {
        seo: {
          name: "seo",
          description: this.$t("message.analytics.tooltip.seo")
        },
        performance: {
          name: "performance",
          description: this.$t("message.analytics.tooltip.performance")
        },
        accessibility: {
          name: "accessibility",
          description: this.$t("message.analytics.tooltip.accessibility")
        },
        best_practices: {
          name: "best_practices",
          description: this.$t("message.analytics.tooltip['best_practices']")
        }
      }
    };
  },
  computed: {
    auditArr() {
      return Object.entries(omit(this.audit.data, "pwa")).map(([k, v]) => {
        return {
          ...v,
          tooltip: this.tooltips[k]
        };
      });
    }
  },

  async created() {
    await this.getCurrentMonth();
    this.emitFromTo(this.currentMonth);
  },

  methods: {
    async changeMonth(val) {
      await this.getCurrentMonth(val);
      this.emitFromTo(val);
    },

    getCurrentMonth(month) {
      month = month || moment();
      this.currentMonth = month;
    },

    emitFromTo(val) {
      const payload = {
        from: moment(val)
          .startOf("month")
          .format("YYYY-MM-DD"),
        to: moment(val)
          .endOf("month")
          .startOf("day")
          .format("YYYY-MM-DD")
      };

      this.$emit("paginationDate", payload);
    }
  }
};
</script>
